import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const quotes = ['Sentía tensión cada vez que pensaba en dinero… y eso fue lo primero que cambió.', 'Dejé de gastar impulsivamente sin darme cuenta.', 'Empecé a tomar decisiones con más calma.', 'No es que gane más… pero ya no pierdo como antes.'];
  return <section className="bg-primary py-10 md:py-16 px-4 md:px-12 border-y border-card" data-id="element-266">
      <div className="max-w-4xl mx-auto" data-id="element-267">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-268">
          {quotes.map((quote, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-secondary p-6 rounded-xl border border-card shadow-md flex items-center" data-id="element-269">
              <div className="text-gold font-playfair text-4xl leading-none mr-4" data-id="element-270">
                "
              </div>
              <p className="font-inter italic text-warm-white text-base md:text-lg" data-id="element-271">
                {quote}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}